module.exports = __webpack_public_path__ + "static/media/edit.77ed806a.svg";